// Trivial single-field form for the Reconciliation tab. Maps onto
// PreflightSettings.cashflow_reconciliation_tolerance (float, default 1.0
// EUR) in preflight.py, consumed by
// compartment_report_calc_service/report_generation/main.py's
// _compute_cashflow_reconciliation_check: |Exaloan Sum - Platform Sum| <=
// tolerance counts as OK instead of a mismatch.

import React from 'react';
import { InputNumber } from 'primereact/inputnumber';

const ReconciliationToleranceForm = ({ tolerance, onChange }) => (
  <div style={{ maxWidth: '20rem' }}>
    <label htmlFor="cashflow-reconciliation-tolerance" className="cr-field-label">
      Cashflow Reconciliation tolerance (EUR)
    </label>
    <InputNumber
      inputId="cashflow-reconciliation-tolerance"
      value={tolerance}
      onValueChange={(e) => onChange(e.value ?? 0)}
      minFractionDigits={0}
      maxFractionDigits={2}
      min={0}
      step={0.1}
      showButtons={false}
      style={{ width: '100%' }}
    />
  </div>
);

export default ReconciliationToleranceForm;
